import FiltersWrapper from './FiltersWrapper';

export default FiltersWrapper;
